import { render, staticRenderFns } from "./EnrolmentPersonal.vue?vue&type=template&id=21f6a7b0&"
import script from "./EnrolmentPersonal.vue?vue&type=script&lang=js&"
export * from "./EnrolmentPersonal.vue?vue&type=script&lang=js&"
import style0 from "./EnrolmentPersonal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports